import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormControl,
  FormGroup,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import {
  ConfigParameter,
  SyncHpcConfig,
} from "src/app/core/models/config-entities";
import { Entities } from "src/app/core/models/globals";
import { ConfigEntityService } from "src/app/core/services/config-entity.service";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { UserRoleNames } from "../../../../core/models/users";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { NavigationService } from "../../../../core/services/navigation.service";
import { ChangeDeploymentNameComponent } from "../../modals/change-deployment-name/change-deployment-name.component";
import { SaveDeploymentSettingsComponent } from "../../modals/save-deployment-settings/save-deployment-settings.component";
import { TemplateFileUploaderComponent } from "../../modals/template-file-uploader/template-file-uploader.component";
import { UpdateCredentialsComponent } from "../../modals/update-credentials/update-credentials.component";
import { UpdateNodeGroupComponent } from "../../modals/update-node-group/update-node-group.component";
import {
  Subject,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  takeUntil,
} from "rxjs";
import { ConfigSectionComponent } from "src/app/modules/pages/config-section/config-section.component";
import { AddNewCredentialComponent } from "src/app/modules/credential/modals/add-new-credential/add-new-credential.component";

@Component({
  selector: "app-deployment-setting",
  templateUrl: "./deployment-setting.component.html",
  styleUrls: ["./deployment-setting.component.scss"],
})
export class DeploymentSettingComopnent implements OnInit {
  depName: string =
    this.route.parent.snapshot.params["deploymentName"] ||
    this.route.snapshot.params["deploymentName"];
  depCloudName: string =
    this.route.parent.snapshot.params["cloudType"] ||
    this.route.snapshot.params["cloudType"];
  // depSettingForm: UntypedFormGroup;
  currentEntity;
  universalSub: Subscription;
  configParameters: ConfigParameter[];
  syncHpcConfigForm: FormGroup;
  isMonitor: boolean =
    this.authenticationService.currentUserValue.role == UserRoleNames.Reader
      ? true
      : false;
  isVdiDep: boolean = true;
  existingNodeGroups: string = "";
  filteredParameters: ConfigParameter[] = [];
  searchTerm: FormControl = new FormControl("");
  destroySub$ = new Subject();
  filterTimeout;
  //@ViewChild("configComp") configSection: ConfigSectionComponent;

  configEntities: ConfigParameter[] = [];
  sectionedConfigEntities: any = {};
  evenSections: any = [];
  oddSections: any = [];
  activeEntity: any;
  activeChild: string = "";
  depSettingForm: FormGroup = new FormGroup({});
  search: FormControl = new FormControl("");
  isCloudConnectorEnabled: boolean = true;

  constructor(
    private route: ActivatedRoute,
    public depService: DeploymentService,
    private navService: NavigationService,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private configEntityService: ConfigEntityService,
    private spinner: NgxSpinnerService,
    private _dialog: MatDialog,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.spinner.show();

    this.universalSub = this.navService.breadcrumbEntity.subscribe((x) => {
      if (this.currentEntity != x) {
        this.currentEntity = x;
      }
    });
    if (this.currentEntity != Entities.Configurator) {
      this.navService.sendLeftPanelIndex(8);
      this.navService.sendParentData("Settings");
    }
    this.depSettingForm = new UntypedFormGroup({});

    this.syncHpcConfigForm = new FormGroup({});

    this.searchTerm.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this.destroySub$)
      )
      .subscribe((val: string) => {
        this.filterParameter(val?.toLowerCase());
      });

    this.checkIsVdiDeployment();
    this.loadDeploymentSettings();
  }

  loadDeploymentSettings() {
    this.configEntityService
      .getDeploymentConfigs(this.depName, this.depCloudName)
      .subscribe({
        next: (data) => {
          if (data == null) {
            this.spinner.hide();
          } else {
            this.configParameters = <ConfigParameter[]>(
              JSON.parse(JSON.stringify(data))
            );
            this.filteredParameters = <ConfigParameter[]>(
              JSON.parse(JSON.stringify(data))
            );

            this.configParameters.forEach((param) => {
              if (!this.sectionedConfigEntities[param.parameterSection]) {
                this.sectionedConfigEntities[param.parameterSection] = [];
              }
              if (param?.parameterName?.toLowerCase() == "node groups") {
                this.existingNodeGroups = param?.parameterValue;
              }
              this.depSettingForm.addControl(
                param.parameterName,
                new FormControl(param.parameterValue, [
                  Validators.pattern(param.parameterRegex),
                ])
              );
              if (param.parameterDisabled) {
                this.depSettingForm.get(param.parameterName).disable();
              }
              this.sectionedConfigEntities[param.parameterSection].push(param);
            });
            this.spinner.hide();
            this.handleConfigEntitiesOperation();
          }
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.destroySub$.next(null);
    this.destroySub$.complete();
    if (this.universalSub) this.universalSub.unsubscribe();
  }

  onReset() {
    const dialogRef = this.dialog.open(SaveDeploymentSettingsComponent, {
      width: "360px",
      data: {
        title: "Reset Changes",
        message: "Do you want to reset changes ?",
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.snackBar.open("Changes reset successful.", "Ok", {
          duration: 3000,
        });
        this.loadDeploymentSettings();
      }
    });
  }

  filterParameter(searchTerm: string): void {
    if (!searchTerm) {
      this.configParameters = this.filteredParameters;
    } else {
      this.configParameters = this.filteredParameters.filter(
        (param) =>
          param.parameterName.toLowerCase().includes(searchTerm) ||
          (param.parameterSection &&
            param.parameterSection?.toLowerCase().includes(searchTerm)) ||
          param.parameterDisplayName.toLowerCase().includes(searchTerm)
      );
    }
    this.configEntities = this.configParameters;
    this.sectionedConfigEntities = {};
    this.handleConfigEntitiesOperation();
  }

  redirectTo() {
    this.router.navigate(["../../../"], { relativeTo: this.route });
    this.navService.sendParentData("");
  }

  onSave(form) {
    const isValid = this.checkIfFormValid();
    if (!isValid) {
      this.snackBar.open("Please enter valid values.", "Ok", {
        duration: 5000,
      });
      return;
    }
    let updatedValues: ConfigParameter[] = this.getValues();
    if (!updatedValues || updatedValues.length == 0) {
      this.snackBar.open("No changes to save.", "Ok", {
        duration: 3000,
      });
      return;
    }

    if (updatedValues && updatedValues.length > 0 && updatedValues.some(x => x.parameterName == "IdleTime")) {
      const idleParam = updatedValues.find(x => x.parameterName === "IdleTime");
      if (idleParam) {
        let idleTimeValue = Number(idleParam.parameterValue);
        if (isNaN(idleTimeValue) || idleTimeValue < 600) {
          this.snackBar.open("Idle time session removal should not be less than 600", "Ok", {
            duration: 3000,
          });
          return;
        }
      }

    }

    const dialogRef = this.dialog.open(SaveDeploymentSettingsComponent, {
      width: "350px",
      data: {
        title: "Save Changes",
        message: "Do you want to save applied changes?",
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.spinner.show();
        let depConfigParameters: ConfigParameter[] = [];
        let isError = false;
        this.depService.isHeadNodeActive(this.depName).subscribe({
          next: (data) => {
            let res = JSON.parse(JSON.stringify(data));
            if (res == false) {
              this.snackBar.open(
                "Make sure the head node is in active state to apply AutoRescaleFlag changes",
                "Ok",
                {
                  duration: 5000,
                }
              );
            }
          },
          error: (err) => { },
        });

        let depConfig: SyncHpcConfig = new SyncHpcConfig(updatedValues);
        this.configEntityService
          .saveDeploymentConfiguration(
            this.depName,
            this.depCloudName,
            depConfig
          )
          .subscribe({
            next: (data) => {
              this.spinner.hide();
              this.snackBar.open(
                "Settings has been Updated Successfully.",
                "Ok",
                {
                  duration: 3000,
                }
              );
              this.loadDeploymentSettings();
            },
            error: (err) => {
              this.spinner.hide();

              // Handle different error status codes
              if (err['status'] == 409) { // Conflict - Active jobs present
                this.snackBar.open(
                  "Cannot update AutoScale settings while jobs are in Active State. Please wait for all jobs to complete.",
                  "Ok",
                  {
                    duration: 6000,
                  }
                );
              } else {
                // Generic error message for other status codes
                const errorMessage = err.error?.message || err.message || "Failed to update settings. Please try again.";
                this.snackBar.open(
                  errorMessage,
                  "Ok",
                  {
                    duration: 5000,
                  }
                );
              }

              // Reload the settings to revert any UI changes
              this.refreshComponent()
            },
          });
      }
    });
  }
  onUpdateCredentials() {
    const dialogRef = this._dialog.open(UpdateCredentialsComponent, {
      disableClose: true,
      width: "400px",
      data: {
        depName: this.depName,
      },
    });
  }

  uploadTemplateFile() {
    const dialogRef = this._dialog.open(TemplateFileUploaderComponent, {
      disableClose: true,
      width: "550px",
      data: {
        depName: this.depName,
      },
    });
  }

  changeDeploymentName() {
    const dialogRef = this._dialog.open(ChangeDeploymentNameComponent, {
      disableClose: true,
      width: "400px",
      data: {
        depName: this.depName,
      },
    });
  }

  checkIsVdiDeployment() {
    if (this.depName.toLowerCase() != "all") {
      this.depService.checkIsVdi(this.depName).subscribe({
        next: (data) => {
          this.isVdiDep = Boolean(data);
        },
        error: (err) => { },
      });
    }
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  onColorChange() { }

  createNodeGroup() {
    const dialogRef = this._dialog
      .open(UpdateNodeGroupComponent, {
        disableClose: true,
        width: "400px",
        data: {
          action: "create",
          depName: this.depName,
          nodeGroups: this.existingNodeGroups,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open(res, "Ok", {
            duration: 5000,
          });
          this.refreshComponent();
        } else {
          return;
        }
      });
  }

  updateNodeGroup() {
    const dialogRef = this._dialog
      .open(UpdateNodeGroupComponent, {
        disableClose: true,
        width: "400px",
        data: {
          action: "update",
          depName: this.depName,
          nodeGroups: this.existingNodeGroups,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open(res, "Ok", {
            duration: 5000,
          });
          this.refreshComponent();
        } else {
          return;
        }
      });
  }

  deleteNodeGroup() {
    const dialogRef = this._dialog
      .open(UpdateNodeGroupComponent, {
        disableClose: true,
        width: "400px",
        data: {
          action: "delete",
          depName: this.depName,
          nodeGroups: this.existingNodeGroups,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open(res, "Ok", {
            duration: 5000,
          });
          this.refreshComponent();
        } else {
          return;
        }
      });
  }

  handleConfigEntitiesOperation(): void {
    this.sectionedConfigEntities = {};
    this.configParameters.forEach((param) => {
      if (!this.sectionedConfigEntities[param.parameterSection]) {
        this.sectionedConfigEntities[param.parameterSection] = [];
      }
      // this.depSettingForm.addControl(param.parameterName, new FormControl(param.parameterValue, [Validators.pattern(param.parameterRegex)]));
      const isParamAlreadyAdded = this.sectionedConfigEntities[
        param.parameterSection
      ].some((p: ConfigParameter) => p.parameterName === param.parameterName);

      if (!isParamAlreadyAdded) {
        // Add param to sectionedConfigEntities if not already present
        this.sectionedConfigEntities[param.parameterSection].push(param);
      }
    });

    this.evenSections = this.getEvenSections();
    this.oddSections = this.getOddSections();
  }

  getEvenSections() {
    let entries = Object.entries(this.sectionedConfigEntities).sort(
      ([keyA], [keyB]) => keyA.localeCompare(keyB)
    );
    // entries = this.ifReaderHideAzureCredentials(entries);
    return entries.slice(0, Math.ceil(entries.length / 2));
  }

  getOddSections() {
    let entries = Object.entries(this.sectionedConfigEntities).sort(
      ([keyA], [keyB]) => keyA.localeCompare(keyB)
    );
    // entries = this.ifReaderHideAzureCredentials(entries);
    return entries.slice(Math.ceil(entries.length / 2));
  }
  getDisplayName(paramName: string): string {
    return this.configParameters.find((x) => x.parameterName == paramName)
      ?.parameterDisplayName;
    //return this.configParameters.find(x => x.parameterName == paramName).parameterName;
  }

  // get values from form which have been changed and return it
  getValues(): ConfigParameter[] | [] {
    let updatedValues: ConfigParameter[] = [];
    Object.keys(this.depSettingForm.controls).forEach((key: any) => {
      if (this.depSettingForm.controls[key].dirty) {
        let param = this.configParameters.find((x) => x.parameterName == key);
        updatedValues.push({
          parameterName: key,
          parameterValue: this.depSettingForm.controls[key].value,
          parameterSection: param.parameterSection,
          parameterDisplayName: param.parameterDisplayName,
          parameterDescription: param.parameterDescription,
          parameterTypeBoolean: param.parameterTypeBoolean,
          parameterDisabled: param.parameterDisabled,
          parameterSettingType: ''
        });
      }
    });
    return updatedValues;
  }

  checkIfFormValid(): boolean {
    return this.depSettingForm.valid;
  }

  updateInfraCred() {
    const dialogRef = this.dialog.open(AddNewCredentialComponent, {
      disableClose: true,
      width: "600px",
      data: { cloudValue: "", cloudName: "", updateForm: true, friendlyName: "none", depName: this.depName },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.res) {
        this.snackBar.open("Credential updated successfully.", "Ok", { duration: 3000 })
      }
      else {
        if (res.data != null && res.data != undefined && res.data != "") {
          this.snackBar.open(res.data, "Ok", { duration: 3000 })
        }
      }
    });
  }

  // This function is written but not used in the code. Upon reviewing the status of weather to show reader credentials.
  ifReaderHideAzureCredentials(entries) {
    if (this.authenticationService.currentUserValue.role == UserRoleNames.Reader) {
      return entries.map((entry: any) => [
        entry[0],
        entry[1].filter(e => !(e.parameterDisplayName && e.parameterDisplayName.includes("Azure"))),
      ]);
    } else {
      return entries;
    }
  }
}
